// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3e36a6b8","232":"8a4fff88","237":"9a9bce0a","526":"e900e610","872":"aa186915"}[chunkId] + ".chunk.js";
};